import { useState } from 'react';
import { NoImagePlaceholder } from './no-image-placeholder';

interface LazyImageProps {
  src?: string;
  alt?: string;
  className?: string;
}

export default function LazyImage({ src, alt = '', className = '' }: LazyImageProps) {
  const [errored, setErrored] = useState(false);

  if (!src || errored) {
    return <NoImagePlaceholder className={className} />;
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={className}
      onError={() => setErrored(true)}
    />
  );
}
